import { wishlistSlice } from './wishlist';
export const wishlistActions = wishlistSlice.actions;

export const { reducer: wishlistReducer } = wishlistSlice;
export * from './types';
